export const PROJECT_FIELDS = [
  "id",
  "logo",
  "name",
  "project_id",
  "status",
  "alias",
  "start_date",
  "end_date",
  "about",
  "statistics",
  {
    industry: ["id", "name"],
  },
  {
    countries: ["country.id","country.name"],
  },
  {
    legal_entity: ["id", "name", "status"],
  },
  {
    coordinator: [
      "id",
      "first_name",
      "last_name",
      "title",
      "avatar",
      "department.name",
      "user.role.name",
    ],
  },
  {
    account_manager: [
      "id",
      "first_name",
      "last_name",
      "title",
      "avatar",
      "department.name",
      "user.role.name",
    ],
  },
  {
    sales_coordinator: [
      "id",
      "first_name",
      "last_name",
      "title",
      "avatar",
      "department.name",
      "user.role.name",
    ],
  },
  {
    tags: [
      "id",
      {
        tag: ["id", "label"],
      },
    ],
  },
];

export const PROJECT_CLIENT_FIELDS = {
  client: ["id", "first_name", "last_name", "email", "company_id.name"],
};
